<template>
<div class="w100">
  <!-- 0306 text-align 스타일 추가 -->
  <el-tree class="mr-r30" style="overflow: hidden; float:left; width: 230px; text-align:left" slot="body" ref="tree" :data="treeData" node-key="treeKey" @node-click="onClickNode" :props="defaultProps" default-expand-all
    :expand-on-click-node="false" highlight-current :filter-node-method="filterNode">
  </el-tree>
  <el-table-wrapper style="float:right; width: calc(100% - 260px);" :data="dataList" :columns="procAutoColumns" :column-default="columnDefault" :pagination="true" @selection-change="procChangeSelection">
    <template slot-scope="scope" slot="autoCommand">
        <el-checkbox disabled v-model="scope.row.processStopAutostartFlag" true-label="1" false-label="0"></el-checkbox>
    </template>
  </el-table-wrapper>
</div>
</template>

<script>
import { isNil, clone, isEmpty, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import { defaultProps } from '@/constants/tree';
import { getValueAfterCheckEmpty } from '@/utils/string';
import TreeFilter from '@/mixins/tree/filter';
import ServerSettingAPI from '@/api/settings/server/server-settings';

export default {
  name: 'WSearchProcessList',
  mixins: [TreeFilter],
  data() {
    return {
      columnDefault,
      isNext: false,
      selectPhysicalNode: null,
      params: {},
      defaultProps,
      dataList: null,
      treeData: null,
      procChangeList: [],
      procAutoColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'processId',
          label: '프로세스 ID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'oneType',
          label: '1차 분류',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'twoType',
          label: '2차 분류',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processName',
          label: '프로세스 명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processStopAutostartFlag',
          label: '명령어 자동실행 여부',
          scopedSlot: 'autoCommand',
          sortable: true,
          searchable: true,
          formatter: this.convertYNFlag,
        },
        {
          prop: 'processCommandStart',
          label: '동작 제어 명령',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processCommandStop',
          label: '정지 제어 명령',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processPort',
          label: '포트번호',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode)) {
          this.params = {};
          if (this.selectPhysicalNode.depth === 3) {
            this.params.majorProcTypeId = this.selectPhysicalNode.majorProcTypeId;
          } else if (this.selectPhysicalNode.depth === 2) {
            this.params.parentMajorProcTypeId = this.selectPhysicalNode.majorProcTypeId;
          }
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadTree() {
      const me = this;
      ServerSettingAPI.getMajorProcessTreeList().then((response) => {
        if (response.data.success) {
          this.treeData = response.data.children;
          this.$nextTick(() => {
            // 트리 데이터의 키값이 담겨져 리턴되기 때문에 루트 데이터의 키를 가져와서
            // 트리 오픈시 설정 될 수 있도록 한다.
            if (!isEmpty(this.treeData) && this.treeData.length > 0) {
              const rootTreeKey = me.treeData[0].treeKey;
              const root = me.$refs.tree.getNode(rootTreeKey);
              this.$refs.tree.setCurrentKey(root);
              me.onClickNode(this.$refs.tree.getCurrentNode());
            }
          });
        }
      });
    },
    loadData() {
      const me = this;
      ServerSettingAPI.getMajorProcessList(me.params).then((response) => {
        if (response.data.success) {
          this.dataList = clone(response.data.data);
        }
      });
    },
    onClickNode(data) {
      this.selectPhysicalNode = cloneDeep(data);
    },
    procChangeSelection(selectVal) {
      this.procChangeList = selectVal;
      this.$emit('changeSize', this.procChangeList.length);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/component/SearchProcessList.vue